// Product Page JavaScript Entry
import "../scss/product.scss";

export function initProductPage() {
	const groupSelector = '.cyprus-product-page .wd-swatches-product';
	const thumbnailSelector = '.cyprus-product-page .wd-gallery-thumb .wd-carousel-item';
	const galleryImageSelector = '.cyprus-product-page .woocommerce-product-gallery__image > a';
	let galleryLightbox = null;
	let galleryLightboxImage = null;

	function closeGalleryLightbox() {
		if (galleryLightbox?.open) {
			galleryLightbox.close();
		}
	}

	function openGalleryLightbox(link) {
		const image = link.querySelector('img');
		const imageUrl = image?.dataset.large_image || image?.currentSrc || link.href;

		if (!imageUrl) {
			return;
		}

		if (!galleryLightbox) {
			galleryLightbox = document.createElement('dialog');
			galleryLightbox.className = 'cyprus-product-lightbox';
			galleryLightbox.setAttribute('aria-label', 'Product image preview');
			galleryLightbox.innerHTML = '<button class="cyprus-product-lightbox__close" type="button" aria-label="Close image preview">×</button><img class="cyprus-product-lightbox__image" alt="">';
			galleryLightboxImage = galleryLightbox.querySelector('.cyprus-product-lightbox__image');
			galleryLightbox.querySelector('.cyprus-product-lightbox__close').addEventListener('click', closeGalleryLightbox);
			galleryLightbox.addEventListener('click', (event) => {
				if (event.target === galleryLightbox) {
					closeGalleryLightbox();
				}
			});
			document.body.appendChild(galleryLightbox);
		}

		galleryLightboxImage.src = imageUrl;
		galleryLightboxImage.alt = image?.alt || '';
		galleryLightbox.showModal();
	}

	function prepareGalleryThumbnails() {
		document.querySelectorAll(thumbnailSelector).forEach((item) => {
			if (item.querySelector('.cyprus-product-thumb__frame')) {
				return;
			}
			const image = item.querySelector('img');

			if (!image) {
				return;
			}

			const frame = document.createElement('span');
			frame.className = 'cyprus-product-thumb__frame';
			image.parentNode.insertBefore(frame, image);
			frame.appendChild(image);
		});
	}

	function preloadGalleryImages() {
		const gallery = document.querySelector('.cyprus-product-page .woocommerce-product-gallery');
		if (!gallery) {
			return;
		}

		const images = gallery.querySelectorAll('.woocommerce-product-gallery__image img, .wd-gallery-thumb img');
		images.forEach((img) => {
			img.setAttribute('loading', 'eager');
			img.setAttribute('decoding', 'async');

			const src = img.getAttribute('data-large_image') || img.getAttribute('data-src') || img.currentSrc || img.src;
			if (src) {
				const preloader = new Image();
				preloader.src = src;
			}

			const srcset = img.getAttribute('data-o_srcset') || img.getAttribute('srcset');
			if (srcset) {
				const candidates = srcset.split(',').map((entry) => entry.trim().split(/\s+/)[0]).filter(Boolean);
				if (candidates.length > 0) {
					const chosen = candidates[Math.min(1, candidates.length - 1)];
					if (chosen && chosen !== src) {
						const preloaderSrcset = new Image();
						preloaderSrcset.src = chosen;
					}
				}
			}
		});
	}

	function positionMobileTabs() {
		const productPage = document.querySelector('.cyprus-product-page');
		const tabs = productPage?.querySelector('.cyprus-product-page__bottom > .cyprus-product-page__tabs, .cyprus-product-page__summary > .cyprus-product-page__tabs');
		const summary = productPage?.querySelector('.cyprus-product-page__summary');

		if (!tabs || !summary) {
			return;
		}

		let placeholder = productPage.querySelector('.cyprus-product-tabs-placeholder');
		if (!placeholder) {
			placeholder = document.createElement('span');
			placeholder.className = 'cyprus-product-tabs-placeholder';
			placeholder.style.display = 'none';
			tabs.parentElement.insertBefore(placeholder, tabs);
		}
		const mobileQuery = window.matchMedia('(max-width: 767px)');

		const updateTabsPosition = () => {
			const target = summary.querySelector('.cyprus-product-page__trust-bar')
				|| summary.querySelector('.cyprus-product-page__purchase');

			if (!target) {
				return;
			}

			if (mobileQuery.matches) {
				if (tabs.parentElement !== summary || tabs.previousElementSibling !== target) {
					target.insertAdjacentElement('afterend', tabs);
				}
			} else {
				if (placeholder.parentElement && tabs.parentElement !== placeholder.parentElement) {
					placeholder.parentElement.insertBefore(tabs, placeholder.nextSibling);
				}
			}
		};

		updateTabsPosition();
		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener('change', updateTabsPosition);
		} else {
			mobileQuery.addListener(updateTabsPosition);
		}
	}

	function syncGroup(group) {
		const swatches = Array.from(group.querySelectorAll('.wd-swatch[role="radio"]'));
		const active = swatches.find((swatch) => swatch.classList.contains('wd-active'));

		swatches.forEach((swatch, index) => {
			const selected = swatch === active;

			swatch.setAttribute('aria-checked', selected ? 'true' : 'false');
			swatch.setAttribute('tabindex', selected || (!active && index === 0) ? '0' : '-1');
			swatch.setAttribute('aria-disabled', swatch.classList.contains('wd-disabled') ? 'true' : 'false');
		});
	}

	function syncAllGroups() {
		prepareGalleryThumbnails();
		preloadGalleryImages();
		document.querySelectorAll(groupSelector).forEach(syncGroup);

		document.querySelectorAll('.cyprus-product-page .single_add_to_cart_button, .cyprus-product-page .wd-buy-now-btn').forEach((button) => {
			const variationForm = button.closest('form.variations_form');
			const variationIdInput = variationForm?.querySelector('input.variation_id');
			const hasSelectedVariation = variationIdInput && Number.parseInt(variationIdInput.value, 10) > 0;
			const unavailable = variationForm
				? !hasSelectedVariation || button.classList.contains('wc-variation-is-unavailable')
				: button.classList.contains('disabled');

			button.disabled = unavailable;
			button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
		});
	}

	function scheduleSync() {
		window.requestAnimationFrame(syncAllGroups);
	}

	document.addEventListener('click', (event) => {
		const galleryLink = event.target.closest(galleryImageSelector);
		if (galleryLink) {
			event.preventDefault();
			openGalleryLightbox(galleryLink);
			return;
		}

		if (event.target.closest(`${groupSelector} .wd-swatch`)) {
			scheduleSync();
		}
	});

	document.addEventListener('keydown', (event) => {
		const current = event.target.closest(`${groupSelector} .wd-swatch[role="radio"]`);

		if (!current || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
			return;
		}

		const group = current.closest(groupSelector);
		const enabledSwatches = Array.from(group.querySelectorAll('.wd-swatch[role="radio"]:not(.wd-disabled)'));
		const currentIndex = enabledSwatches.indexOf(current);
		const direction = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
		const nextIndex = (currentIndex + direction + enabledSwatches.length) % enabledSwatches.length;
		const next = enabledSwatches[nextIndex];

		if (next) {
			event.preventDefault();
			next.focus();
			next.click();
		}
	});

	function initPriceSync() {
		const priceContainer = document.querySelector('.cyprus-product-page__price');
		if (!priceContainer || priceContainer.dataset.originalPrice) {
			return;
		}
		priceContainer.dataset.originalPrice = priceContainer.innerHTML;
	}

	function handleFoundVariationPrice(variation) {
		const priceContainer = document.querySelector('.cyprus-product-page__price');
		if (!priceContainer) {
			return;
		}
		if (!priceContainer.dataset.originalPrice) {
			priceContainer.dataset.originalPrice = priceContainer.innerHTML;
		}
		if (variation && variation.price_html && variation.price_html.trim().length > 0) {
			priceContainer.innerHTML = variation.price_html;
		}
	}

	function handleResetPrice() {
		const priceContainer = document.querySelector('.cyprus-product-page__price');
		if (priceContainer && priceContainer.dataset.originalPrice) {
			priceContainer.innerHTML = priceContainer.dataset.originalPrice;
		}
	}

	function handleVariationGallery() {
		const galleryWrapper = document.querySelector('.woocommerce-product-gallery__wrapper');
		if (galleryWrapper && galleryWrapper.swiper) {
			galleryWrapper.swiper.slideTo(0);
		}
	}

	function handleResetGallery() {
		const galleryWrapper = document.querySelector('.woocommerce-product-gallery__wrapper');
		if (galleryWrapper && galleryWrapper.swiper) {
			galleryWrapper.swiper.slideTo(0);
		}
	}

	function initTabsNavigation() {
		const tabLinks = document.querySelectorAll('.cyprus-product-page .woocommerce-tabs ul.tabs li a');
		tabLinks.forEach((tabLink) => {
			tabLink.addEventListener('click', (event) => {
				const href = tabLink.getAttribute('href');
				if (!href || !href.startsWith('#')) {
					return;
				}
				const targetPanel = document.querySelector(href);
				if (targetPanel) {
					event.preventDefault();
					targetPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });

					const tabList = tabLink.closest('ul.tabs');
					tabList?.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
					tabLink.closest('li')?.classList.add('active');

					// Track tab click only if existing analytics is detected
					if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
						window.dataLayer.push({
							event: 'product_tab_click',
							tab_name: tabLink.textContent?.trim() || href
						});
					} else if (typeof window.gtag === 'function') {
						window.gtag('event', 'select_content', {
							content_type: 'product_tab',
							item_id: href
						});
					}
				}
			});
		});
	}

	positionMobileTabs();
	initPriceSync();
	initTabsNavigation();
	preloadGalleryImages();

	if (window.jQuery) {
		window.jQuery(document).on('found_variation', (event, variation) => {
			handleFoundVariationPrice(variation);
			handleVariationGallery();
			scheduleSync();
		});
		window.jQuery(document).on('reset_data', () => {
			handleResetPrice();
			handleResetGallery();
			scheduleSync();
		});
		window.jQuery(document).on('woocommerce_variation_has_changed wdResetVariation wdShowVariationNotQuickView', scheduleSync);
		window.jQuery(syncAllGroups);
	} else {
		syncAllGroups();
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initProductPage);
} else {
	initProductPage();
}
